




















import {Vue, Component} from 'vue-property-decorator';
import ProjectBlock from '@/components/ProjectBlock.vue';
import {ProjectWork} from '@/interfaces/ProjectWork';

@Component({
    name: 'Work',
    components: {ProjectBlock},
})
export default class Work extends Vue {
    public projects: ProjectWork[] = [
        {
            image: 'kuwait-4.jpg',
            title: 'Al-Salem Cultural Centre',
            description: '33 interactive applications for the biggest museum in the world.',
            path: '/projects/al-salem-cultural-centre',
        },
        {
            image: 'zuja-2.jpg',
            title: 'Ožujsko',
            description: 'Websites for Ožujsko.',
            path: '/projects/ozujsko',
        },
        {
            image: 'eotg-3.jpg',
            title: 'Eye on the goal',
            description: 'School improvement system.',
            path: '/projects/eye-on-the-goal',
        },
        {
            image: 'fraud-5.jpg',
            title: 'Mercury processing services',
            description: 'Fraud management platform.',
            path: '/projects/mercury-fraud',
        },
        {
            image: 'vremenco.jpg',
            title: 'Vremenco',
            description: 'Task tracking tool.',
            path: '/projects/vremenco',
        },
    ];
}
